import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createChassisCode,
  getChassisCode,
  getChassisCodes,
  editChassisCode,
  deleteChassisCode,
} from "api/chassisCodeApi"

export const CHASSIS_CODE_QUERY_KEY = "chassis_codes"

export const useChassisCodes = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [CHASSIS_CODE_QUERY_KEY, params],
    queryFn: () => getChassisCodes(params),
    keepPreviousData: true,
    enabled,
  })
}

export const useChassisCode = id => {
  return useQuery({
    queryKey: [CHASSIS_CODE_QUERY_KEY, id],
    queryFn: () => getChassisCode(id),
    enabled: !!id,
  })
}

export const useCreateChassisCode = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createChassisCode,
    onSuccess: () => queryClient.invalidateQueries([CHASSIS_CODE_QUERY_KEY]),
  })
}

export const useEditChassisCode = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: editChassisCode,
    onSuccess: () => queryClient.invalidateQueries([CHASSIS_CODE_QUERY_KEY]),
  })
}

export const useDeleteChassisCode = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteChassisCode,
    onSuccess: () => queryClient.invalidateQueries([CHASSIS_CODE_QUERY_KEY]),
  })
}
